var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsDeleteIcon = function SvgDsDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.333 8a.667.667 0 0 0-.666-.667H6.333a.667.667 0 0 0 0 1.334h3.334A.667.667 0 0 0 10.333 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.327 3.784h3.34a.667.667 0 1 1 0 1.333h-.21l-1.665 8.452c-.129.654-.193.981-.37 1.222a1.33 1.33 0 0 1-.505.415c-.27.127-.604.127-1.27.127H5.353c-.667 0-1 0-1.27-.127a1.33 1.33 0 0 1-.506-.415c-.177-.24-.241-.568-.37-1.222L1.543 5.117h-.21a.667.667 0 1 1 0-1.333h3.34a3.334 3.334 0 0 1 6.653 0m-1.339 0H6.012a2 2 0 0 1 3.976 0m-5.472 9.528L2.955 5.385h10.09l-1.561 7.927a10 10 0 0 1-.143.663l-.003.012-.013.001C11.189 14 11 14 10.647 14H5.353c-.355 0-.543-.001-.679-.012h-.013l-.003-.013a10 10 0 0 1-.143-.663",
    clipRule: "evenodd"
  })));
};
export default SvgDsDeleteIcon;